import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import Locales from 'locales';
import { Urls } from 'data';

const LegalNotice = ({ cta = null }) => {
  return (
    <div className="max-w-3xl mx-auto rounded-sm bg-white p-8 shadow-lg border space-y-6 z-50">
      <p className="text-gray-700 leading-relaxed">
        {Locales.formatString(Locales.cgu.modal.first_part, {
          legal: <strong>{Locales.cgu.modal.legal}</strong>,
          cgu: <strong>{Locales.cgu.modal.cgu}</strong>,
          confidentiality: <strong>{Locales.cgu.modal.confidentiality}</strong>,
        })}
      </p>

      <p className="text-gray-700 leading-relaxed">{Locales.cgu.modal.second_part}</p>

      <div className="text-gray-700">
        <p className="mb-2 font-medium">{Locales.cgu.modal.third_part.title}</p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            {Locales.formatString(Locales.cgu.modal.third_part.legal, {
              legal: (
                <a
                  href={Urls.legal_mention}
                  target="_blank"
                  rel="noreferrer"
                  className="text-hajj-primary hover:text-hajj-secondary font-medium underline"
                >
                  {Locales.cgu.modal.legal}
                </a>
              ),
            })}
          </li>
          <li>
            {Locales.formatString(Locales.cgu.modal.third_part.cgu, {
              cgu: (
                <a
                  href={Urls.cgu}
                  target="_blank"
                  rel="noreferrer"
                  className="text-hajj-primary hover:text-hajj-secondary font-medium underline"
                >
                  {Locales.cgu.modal.cgu}
                </a>
              ),
            })}
          </li>
          <li>
            {Locales.formatString(Locales.cgu.modal.third_part.confidentiality, {
              confidentiality: (
                <a
                  href={Urls.legal_mention}
                  target="_blank"
                  rel="noreferrer"
                  className="text-hajj-primary hover:text-hajj-secondary font-medium underline"
                >
                  {Locales.cgu.modal.confidentiality}
                </a>
              ),
            })}
          </li>
          <li>
            {Locales.formatString(Locales.cgu.modal.third_part.cookie, {
              cookie: (
                <a
                  href={Urls.cookie_policy}
                  target="_blank"
                  rel="noreferrer"
                  className="text-hajj-primary hover:text-hajj-secondary font-medium underline"
                >
                  {Locales.cgu.modal.cookie}
                </a>
              ),
            })}
          </li>
        </ul>
      </div>

      <p className="text-gray-700 leading-relaxed">
        {Locales.formatString(Locales.cgu.modal.fourth_part, {
          btn: <strong>{Locales.cgu.modal.btn}</strong>,
        })}
      </p>

      <div className="flex justify-end">
        <Button variant="default" size="lg" className="bg-green-600 hover:bg-green-700 text-white" onClick={cta}>
          {Locales.cgu.modal.btn}
        </Button>
      </div>
    </div>
  );
};

LegalNotice.propTypes = {
  cta: PropTypes.func,
};

export default LegalNotice;
